import { render } from "./SuppliersNewPage.vue?vue&type=template&id=a60abbd4&ts=true"
import script from "./SuppliersNewPage.vue?vue&type=script&lang=ts"
export * from "./SuppliersNewPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__